/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { isArrayNotEmpty } from "utils/empty-exists";

const JSONFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    let value = item?.value;
                    if (value && typeof value !== "string") {
                        value = "Error occurred while retrieving value";
                    }

                    return value &&
                        <Fragment key={index}>
                            <pre style={{
                                fontSize: "12px", maxWidth: "800px", maxHeight: "700px", overflow: "auto",
                            }}
                            >
                                {value}
                            </pre>
                        </Fragment>;
                })
            }
        </FieldDisplayWrapper>
    );
};
JSONFieldDisplay.displayName = "JSONFieldDisplay";
export { JSONFieldDisplay };
